import { Box, Label } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { OnChangeValue, ActionMeta } from 'react-select';
import { Domain } from '@tiendanube/common/src/enums';
import MultiSelect from 'commons/components/MultiSelect';
import { OptionType } from 'commons/components/MultiSelect/multiSelectStyleConfig';

interface OrderPaymentProvidersFilterProps {
  defaultValue: OptionType[];
  paymentProviderOptions: OptionType[];
  onChange: (
    newValue: OnChangeValue<OptionType, true>,
    action: ActionMeta<OptionType>,
  ) => void;
}

function OrderPaymentProvidersFilter({
  defaultValue,
  paymentProviderOptions,
  onChange,
}: Readonly<OrderPaymentProvidersFilterProps>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Label htmlFor="payment-provider-select">
        {t('filter.paymentProvider')}
      </Label>
      <MultiSelect
        inputId="payment-provider-select"
        defaultValue={defaultValue}
        options={paymentProviderOptions}
        placeholder={t('filters.paymentProvider.all')}
        onChange={onChange}
      />
    </Box>
  );
}

export default OrderPaymentProvidersFilter;
